import * as ko from "knockout";
import template from './ContentFooter.html';

class ContentFooter {

  footerText: ko.Observable<string> = ko.observable<string>("");
  link1Text: ko.Observable<string> = ko.observable<string>("");
  link1Uri: ko.Observable<string> = ko.observable<string>("");
  link2Text: ko.Observable<string> = ko.observable<string>("");
  link2Uri: ko.Observable<string> = ko.observable<string>("");
  link3Text: ko.Observable<string> = ko.observable<string>("");
  link3Uri: ko.Observable<string> = ko.observable<string>("");

  // Computed properties - initialized in constructor
  selectedLanguage: ko.PureComputed<string>;

  constructor() {
    // Initialize computed properties
    this.selectedLanguage = ko.pureComputed<string>(() => global.Logonme.SelectedLanguage());

    this.updateStrings(this.selectedLanguage());
    this.selectedLanguage.subscribe((lang: string) => {
      this.updateStrings(lang);
    });
  }

  private updateStrings(lang: string): void {
    this.footerText(global.Logonme.LocalizationManager.getText('content-footer-text', lang, ''));
    this.link1Uri(global.Logonme.LocalizationManager.getText('content-footer-link1-src', lang, ''));
    this.link1Text(global.Logonme.LocalizationManager.getText('content-footer-link1-text', lang, ''));
    this.link2Uri(global.Logonme.LocalizationManager.getText('content-footer-link2-src', lang, ''));
    this.link2Text(global.Logonme.LocalizationManager.getText('content-footer-link2-text', lang, ''));
    this.link3Uri(global.Logonme.LocalizationManager.getText('content-footer-link3-src', lang, ''));
    this.link3Text(global.Logonme.LocalizationManager.getText('content-footer-link3-text', lang, ''));
  }
}

export default { viewModel: ContentFooter, template: template };
